export const GET_LOGIN_URL_REQUEST = 'GET_LOGIN_URL_REQUEST';
export const GET_LOGIN_URL_SUCCESS = 'GET_LOGIN_URL_SUCCESS';
export const GET_LOGIN_URL_FAILURE = 'GET_LOGIN_URL_FAILURE';

export const GET_LOGOUT_URL_REQUEST = 'GET_LOGOUT_URL_REQUEST';
export const GET_LOGOUT_URL_SUCCESS = 'GET_LOGOUT_URL_SUCCESS';
export const GET_LOGOUT_URL_FAILURE = 'GET_LOGOUT_URL_FAILURE';

export const GET_TOKEN_DATA_REQUEST = 'GET_TOKEN_DATA_REQUEST';
export const GET_TOKEN_DATA_SUCCESS = 'GET_TOKEN_DATA_SUCCESS';
export const GET_TOKEN_DATA_FAILURE = 'GET_TOKEN_DATA_FAILURE';

export const LOAD_USER_REQUEST = 'LOAD_USER_REQUEST';
export const LOAD_USER_SUCCESS = 'LOAD_USER_SUCCESS';
export const LOAD_USER_FAILURE = 'LOAD_USER_FAILURE';

export const LOAD_PERMISSIONS_REQUEST = 'LOAD_PERMISSIONS_REQUEST';
export const LOAD_PERMISSIONS_SUCCESS = 'LOAD_PERMISSIONS_SUCCESS';
export const LOAD_PERMISSIONS_FAILURE = 'LOAD_PERMISSIONS_FAILURE';

export const CHECK_TOKEN_REQUEST = 'CHECK_TOKEN_REQUEST';
export const CHECK_TOKEN_SUCCESS = 'CHECK_TOKEN_SUCCESS';
export const CHECK_TOKEN_FAILURE = 'CHECK_TOKEN_FAILURE';

export const REMOVE_PERMISSIONS = 'REMOVE_PERMISSIONS';
